import styled from 'styled-components';

export const DateSelect = styled.div`
    display: flex;
    justify-content: space-between;

    width: 100%;
    user-select: none;

    input{
        width: 100%;
    }
`